import React from "react";

const VitaminCTimeline = () => {
  return (
    <div className="py-16 px-8 ">
      <div className="max-w-screen-xl mx-auto text-center">
      <h2 className="text-6xl font-extrabold text-gray-900   underline decoration-yellow-500">
      ビタミンCサプリメントでの変化の過程
        </h2>
        <p className="mt-8 text-xl text-gray-700 ">
        ビタミンCを摂取することで実感できる6つの変化
        </p>
      </div>
   
      {/* Timeline Container */}
      <div className="relative mt-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">

          {/* Step 1: Boosting Immunity */}
          <div className="relative w-full md:w-1/5 text-center">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center">
              1
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/covid-19-healthcare-medical-concept-cheerful-asian-girl-shows-arm-with-patch-after-coronavirus-vaccination-getting-shot-vaccine-standing-happy-yellow-background_1258-83146.jpg?t=st=1743512989~exp=1743516589~hmac=1ce6e9d50867d636bc1c4852c0451addf1b58e83196d03a1a1d5ca26ea76c00f&w=1380"
              alt="Boost Immunity"
            />
                                                                      <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">免疫力の強化</span>
</h3>
       
            {/* <h3 className="text-xl font-semibold text-gray-800 mt-4">免疫力の強化</h3> */}
            <p className="mt-2 text-gray-600">
              ビタミンCが免疫機能を強化し、風邪や病気から体を守ります。
            </p>
          </div>

          {/* Step 2: Radiant Skin - Centered */}
          <div className="relative w-full md:w-1/5 text-center md:col-span-3">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center">
              2
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/half-face-lovely-model_23-2148376632.jpg?t=st=1743513031~exp=1743516631~hmac=81339c41143873045314ad49ce6c85a00e03606d395c7c4a2d169de0704ff066&w=740"
              alt="Radiant Skin"
            />
                                                          <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">輝く肌</span>
</h3>
            {/* <h3 className="text-xl font-semibold text-gray-800 mt-4">輝く肌</h3> */}
            <p className="mt-2 text-gray-600">
              コラーゲン生成をサポートし、肌の明るさと健康を促進します。
            </p>
          </div>

          {/* Step 3: Increased Energy */}
          <div className="relative w-full md:w-1/5 text-center">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-yellow-600 text-white rounded-full flex items-center justify-center">
              3
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/happy-smiling-athletic-woman-with-arms-outstretched_1150-4192.jpg?t=st=1743513486~exp=1743517086~hmac=76f2f7ec6f26dadf000c56ba915ca7136bbc1623f102d579dd8fcc759f30e68c&w=740"
              alt="Increased Energy"
            />
                                              <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">エネルギーの増加</span>
</h3>
            {/* <h3 className="text-xl font-semibold text-gray-800 mt-4">エネルギーの増加</h3> */}
            <p className="mt-2 text-gray-600">
              疲れにくくなり、日々の生活で活力を感じるようになります。
            </p>
          </div>

        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mt-8">
          {/* Step 4: Mental Clarity */}
          <div className="relative w-full md:w-1/5 text-center">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center">
              4
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/side-view-woman-spending-time-outdoors_23-2150100086.jpg?t=st=1743513302~exp=1743516902~hmac=720815c9dc7bf50eb10b732d166a569599c7f8d8d55252975875b5cc129d730e&w=740"
              alt="Mental Clarity"
            />
                                  <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">精神的明晰さ</span>
</h3>

            {/* <h3 className="text-xl font-semibold text-gray-800 mt-4">精神的明晰さ</h3> */}
            <p className="mt-2 text-gray-600">
              ストレスの軽減と集中力向上で、精神がクリアになります。
            </p>
          </div>
          <div className="relative w-full md:w-1/5 text-center">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-purple-600 text-white rounded-full flex items-center justify-center">
              5
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/woman-enjoying-their-sunny-holiday_23-2149283976.jpg?t=st=1743520252~exp=1743523852~hmac=577fe095211fb628e82154edb3af4de911b7b1482a3c2cfc589960e5810f9f8d&w=1380"
              alt="Overall Vitality"
            />
          <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">水分補給とデトックス</span>
</h3>

  <p className="mt-2 text-gray-600">
    ビタミンCは体の水分バランスを整え、デトックスをサポートします。
  </p>
          </div>
          {/* Step 5: Overall Vitality */}
          <div className="relative w-full md:w-1/5 text-center">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-purple-600 text-white rounded-full flex items-center justify-center">
              6
            </div>
            <img
              className="w-full h-64 object-cover rounded-2xl"
              src="https://img.freepik.com/free-photo/full-shot-woman-enjoying-nature_23-2149031272.jpg?t=st=1743513381~exp=1743516981~hmac=3c2635312a30df66c4301b069310a0535807920946e0846d9aed022381066786&w=740"
              alt="Overall Vitality"
            />
                      <h3 className="relative text-xl font-semibold text-gray-800 mt-4 inline-block">
  <span className="absolute inset-0 bg-yellow-300 w-full h-4 top-1/2 transform -translate-y-1/2 -rotate-2 opacity-60 rounded-lg"></span>
  <span className="relative">全体的な活力</span>
</h3>

        
            <p className="mt-2 text-gray-600">
              ビタミンCの摂取で全身の活力が増し、元気に過ごせるようになります。
            </p>
          </div>
        
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <h2 className="text-3xl font-bold text-gray-800">今すぐ、ビタミンCサプリメントを試してみよう！</h2>
        <p className="mt-4 text-2xl text-gray-600">
          あなたもこの変化を実感しましょう！今すぐ「購入する」ボタンをクリックして、ビタミンCサプリメントを手に入れてください。
        </p>
        <a
          href="/#sell"
          className="mt-6 inline-flex items-center justify-center bg-yellow-500 text-white hover:bg-yellow-600 text-white py-3 px-6 rounded-2xl shadow-2xl  transition-colors"
        >
          今すぐ購入
          <svg
            className="ml-2 w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default VitaminCTimeline;
